









import Vue from "vue";
import ToolbarGroup from "./components/ToolbarGroup.vue";
import { toolbarMenu } from "./store/store";
import { DynamicItem, MenuToolbar } from "./interfaces/ToolbarItem";

export default Vue.extend({
  props: {
    menu: {
      type: Array as () => MenuToolbar[],
    },
    config: {
      type: Object,
    },
  },
  data() {
    return {
      dynamicItemLimit: 0,
    };
  },
  methods: {
    inArray(data: MenuToolbar[], path: string): boolean {
      const pathSplited = path.split("/");
      return !!data?.find((link: MenuToolbar) => {
        const linkSplitted = link.path?.split("/");
        if(pathSplited.includes('propass')){
          return true;
        }
        return linkSplitted[linkSplitted.length - 1] === pathSplited[pathSplited.length - 1];
      });
    },
    handleDelete(item: DynamicItem): void {
      this.dynamicMenu = this.dynamicMenu.filter(link => link.id != item.id);
      if (toolbarMenu.routingPath == item.path) {
        if (toolbarMenu.dynamicMenu.find((link: DynamicItem) => link.path !== item.path)) {
          this.$router.go(-1);
        } else {
          this.$router.push({ name: this.config.pushToPage });
        }
      }
    },
    setItem(name: string, menu: DynamicItem[]): void {
      try {
        localStorage.setItem(name, JSON.stringify(menu));
      } catch {
        throw Error("Cant storage the data");
      }
    },
    generatePosition(menu: DynamicItem[]): number {
      if (menu.length > 0) {
        const positions = menu.map((item: DynamicItem) => {
          return item.position;
        });
        return Math.max(...positions) + 1;
      }
      return 1;
    },
    getPosition(menu: DynamicItem[], id: string): number | undefined {
      return menu.find((item: DynamicItem) => item.id == id)?.position;
    },
    watchRouter(to: string, params: string, query: string | unknown): void {
      if (params) {
        const toSplited = to.split("/");
        if (toSplited.includes(params)) {
          const link = toolbarMenu.dynamicMenu.find((link: DynamicItem) => link.id == params) as DynamicItem;
          const menu = toolbarMenu.dynamicMenu.filter((link: DynamicItem) => link.id != params);
          const labelSplited = link.label!.split("|");
          const newPath = `/${toSplited[1]}/${params}/${toSplited.slice(3).reduce((a, b) => a + "/" + b)}`;
          const position = this.getPosition(toolbarMenu.dynamicMenu, params);
          const toolbarItem = {
            id: params,
            label: `${labelSplited[0]}| ${toSplited[toSplited.length - 1]}`,
            path: newPath,
            position: position,
            name: query,
          } as DynamicItem;
          menu.push(toolbarItem);
          toolbarMenu.dynamicMenu = menu;
          this.setItem(this.config.id, toolbarMenu.dynamicMenu);
        }
      }
    },
    getLimitItem(size: number): number {
      let tabSize = 170;
      if (this.config.tabSize) {
        tabSize = this.config.tabSize;
      }
      const sizeLimit = size - 390;
      if (sizeLimit >= 170) {
        return Math.floor(sizeLimit / tabSize);
      } else {
        return 0;
      }
    },
  },
  components: { ToolbarGroup },
  async mounted() {
    const dynamicMenu = localStorage.getItem(this.config.id);
    if (dynamicMenu && toolbarMenu.dynamicMenu.length == 0 && dynamicMenu.length) {
      toolbarMenu.dynamicMenu = [...JSON.parse(localStorage.getItem(this.config.id)!)];
    }


    if (!this.inArray(this.menu, toolbarMenu.routingPath) && !this.$route.query.jwtPayload && !this.$route.query.redirect && !this.$route.query.m) {
      let label,
        id,
        path = "" as any;
      if (this.config.routeQuery && this.$route.query[this.config.routeQuery]) {
        label = this.$route.query[this.config.routeQuery];
        path = "test";
        id = this.$route.query[this.config.routeQuery]
      } else if (toolbarMenu.routeParams) {
        label = await this.config.getLabel(toolbarMenu.routeParams);
        path = toolbarMenu.routingPath.split("/");
        id = toolbarMenu.routeParams;
      }
      const position = this.generatePosition(toolbarMenu.dynamicMenu);
      const toolbarItem = {
        id,
        label: `${label} | ${path[path.length - 1]}`,
        path: toolbarMenu.routingPath,
        position: position,
      } as any;

      if (this.config && this.config.popupQuery && this.$route.query[this.config.routeQuery]) {
        toolbarItem.name = await this.config.getPopupName(this.$route.query[this.config.routeQuery]);
      }

      if (!this.dynamicMenu.find(link => link.id === toolbarItem.id)) {
        this.dynamicMenu.push(toolbarItem);
        this.setItem(this.config.id, this.dynamicMenu);
      }
    }
    this.getLimitItem(this.$vuetify.breakpoint.width);

  },
  computed: {
    dynamicMenu: {
      get(): DynamicItem[] {
        return toolbarMenu.dynamicMenu.sort((a: DynamicItem, b: DynamicItem) => a.position - b.position);
      },
      set(dynamicMenu: DynamicItem[]): void {
        toolbarMenu.dynamicMenu = dynamicMenu;
        this.setItem(this.config.id, dynamicMenu);
      },
    },
    windowWidth(): number {
      return this.$vuetify.breakpoint.width;
    },
    itemLimit(): number {
      return this.dynamicItemLimit;
    },
  },
  watch: {
    "$route.fullPath": {
      handler(to, from) {
        toolbarMenu.routingPath = to;
        this.watchRouter(to, toolbarMenu.routeParams, this.$route.params.taskDefinitionKey);
      },
      immediate: true,
    },
    "$route.params": {
      handler(to, from) {
        toolbarMenu.routeParams = to[this.config.nameParams];
      },
      immediate: true,
    },
    windowWidth: {
      handler(to, from) {
        this.dynamicItemLimit = this.getLimitItem(to);
      },
      immediate: true,
    },
  },
});
